import React from 'react'
import styled from 'styled-components'

const CardWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 1rem;

    border-bottom:1px solid #5A5A5A;
`
const Box = styled.div`

`
const Row = styled.div`

    display:flex;
    justify-content: space-between;


`
const BoxText = styled.div`
    margin-bottom: 1.2rem;
    height:2rem;
    p{
        font-size: 0.9rem;
        font-family: "Poppins";
        font-weight: 500;
        height: 0.2rem;
    }

    .textPrimary{
        font-size: 1rem;
        font-family: "Poppins";
        font-weight: 600;
    }


`


const CardDataTiny = ({ client, number }) => {

    return (
        <CardWrapper>
            <Row>
                <Box>
                    <BoxText>
                        <p>Natureza da operação</p>
                        <p className='textPrimary'>Venda de mercadorias</p>
                    </BoxText>
                    <BoxText>
                        <p>Cliente</p>
                        <p className='textPrimary'>{client}</p>
                        
                    </BoxText>
                </Box>
            </Row>
            <Row>
                <BoxText>
                    <p>Número</p>
                    <p className='textPrimary'>{number}</p>
                </BoxText>

                
            </Row>

        </CardWrapper>
    )
}

export default CardDataTiny